import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
const apiUrl = process.env.REACT_APP_API_URL;
const apiKey = process.env.REACT_APP_API_KEY;
const BookingConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const booking = location.state?.booking;


  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
    <div className="bg-white shadow-xl rounded-2xl p-8 max-w-md w-full text-center">
      {/* Success Icon */}
      <div className="flex justify-center">
        <div className="bg-green-100 rounded-full p-4">
          <span className="text-green-600 text-4xl">✅</span>
        </div>
      </div>
  
      {/* Title */}
      <h1 className="mt-4 text-3xl font-bold text-green-600">
        Booking Confirmed!
      </h1>
  
      {/* Details */}
      {booking && (
        <div className="mt-6 space-y-3 text-gray-700">
             <p className="text-lg">
            <span className="font-semibold">✅ Booking id:</span> {booking.bookingId}
          </p>
          <p className="text-lg">
            <span className="font-semibold">🏟️ Ground:</span> {booking.groundName}
          </p>
          <p className="text-lg">
            <span className="font-semibold">📅 Date:</span> {booking.bookingDate}
          </p>
          <p className="text-lg">
            <span className="font-semibold">⏰ Slot:</span> {booking.slot}
          </p>
          <p className="text-lg">
            <span className="font-semibold">🌆 City:</span> {booking.city}
          </p>
          <p className="text-lg">
            <span className="font-semibold">⚽ Sport:</span> {booking.sport}
          </p>
        </div>
      )}
  
      {/* Action Button */}
      <div className="mt-8">
        <button
          onClick={() => navigate("/")}
          className="px-6 py-3 bg-blue-600 text-white rounded-xl font-semibold shadow hover:bg-blue-700 transition-transform transform hover:scale-105"
        >
          Back to Home
        </button>
      </div>
    </div>
  </div>
  );
};

export default BookingConfirmation;